import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  Route,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';
import {Observable} from "rxjs/Observable";
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';


@Injectable()
export class CanActivateAuthGuard implements CanActivate, CanActivateChild {

  constructor(private _afAuth: AngularFireAuth, private router: Router) {}

  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.canActivate(next, state);
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this._afAuth.authState.map((auth) => {
          if (!auth) {
            this.router.navigateByUrl('login');
            return false;
          }
          return true;
      }).take(1);
  }
}


/*
Copyright 2016 JohnPapa.net, LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://bit.ly/l1cense
*/



// WEBPACK FOOTER //
// C:/Users/Alec/Documents/dev/recog/recog/src/app/app-core/can-activate.service.ts